if($('footer#footer').length){
    $('.footer-bottom').insertAfter('footer#footer').wrap('<div class="underFooter"></div>')
    $('#signature').append('<span class="signatureFirm"> | <a href="https://www.d2solutions.cz/" target="_blank">D2solutions</a> | <a href="https://www.shopcode.cz/" target="_blank">ShopCode</a></span>')
    $('footer#footer').before($('footer#footer .sharePlugin'))    
    $('footer#footer').after($('footer#footer .dotationText'))
    $('footer#footer .contact-box').append($('footer#footer .customSocial'))
    $('footer#footer .contact-box span.instagram').closest('li').appendTo('.customSocial')
    $('footer#footer .contact-box span.facebook').closest('li').appendTo('.customSocial')

    $('footer#footer .contact-box span.pinterest').closest('li').appendTo('.customSocial')
    $('footer#footer .contact-box span.youtube').closest('li').appendTo('.customSocial')
    $(document).on('click', '.custom-footer>div h4', function(){
        $(this).closest('.custom-footer>div').toggleClass('openIt')
    })
    $('header#header .header-top').prepend($('footer#footer .headerLeft').clone())
    $('header#header .header-top .navigation-buttons').prepend($('footer#footer .headerRight').clone())
    $('.navigationActions').append($('footer#footer .headerLeft>ul>*').clone())
    $('.navigationActions').append($('footer#footer .headerRight>ul>*').clone())
}
else{
    var storedloadedFooter = sessionStorage.getItem('loadedFooter');
    if (storedloadedFooter) {
        $('header#header .header-top').prepend($(storedloadedFooter).find('.headerLeft')[0])
        $('header#header .header-top .navigation-buttons').prepend($(storedloadedFooter).find('.headerRight')[0])
    } else {
          
    }
    var url = "/";
    $.get(url, function(data) {
        var $data = $(data);
        var $loadedFooter = $data.find("footer#footer").html();
        sessionStorage.setItem('loadedFooter', $loadedFooter);
    })
}